// ---------------------------------------------------------------------------
// THE ICON VOCABULARY (DESIGN.md §10): Iconsax (iconsax-react), one family.
//
// Icons are imported by name so the bundle carries only the glyphs the product
// draws (the package ships ~1,000 icons × 6 variants; `import *` would pull
// them all in). To draw a new icon, add its Iconsax export here and name it in
// §10 — the registry IS the vocabulary, so the same thing is always drawn with
// the same glyph across the portal.
// ---------------------------------------------------------------------------
import {
  Activity,
  Add,
  AddSquare,
  Alarm,
  Archive,
  ArchiveBook,
  ArchiveBox,
  ArrowDown,
  ArrowDown2,
  ArrowLeft,
  ArrowLeft2,
  ArrowRight,
  ArrowRight2,
  ArrowSwapHorizontal,
  ArrowUp2,
  Bill,
  Briefcase,
  Broom,
  Building,
  Buildings2,
  Box1,
  Calendar,
  Car,
  CalendarEdit,
  CalendarTick,
  Call,
  CallCalling,
  CallOutgoing,
  CallRemove,
  CallSlash,
  Category,
  Chart,
  Chart2,
  ClipboardTick,
  Clock,
  CloseCircle,
  Cloud,
  Code,
  Code1,
  Copy,
  CopySuccess,
  Cpu,
  Crown,
  Cup,
  Danger,
  DirectboxReceive,
  DirectboxSend,
  Document,
  DocumentCode,
  DocumentCopy,
  DocumentDownload,
  DocumentText,
  DocumentSketch,
  DocumentUpload,
  Edit,
  Edit2,
  Eraser,
  Export,
  ExportSquare,
  Eye,
  EyeSlash,
  Flag,
  Flash,
  Folder,
  FolderAdd,
  Folder2,
  FolderOpen,
  Gallery,
  Global,
  Image,
  Headphone,
  InfoCircle,
  Kanban,
  KeySquare,
  Link2,
  Link21,
  Location,
  Lock1,
  MagicStar,
  Maximize4,
  Medal,
  MedalStar,
  MessageQuestion,
  MessageEdit,
  Messages2,
  Microphone2,
  MicrophoneSlash,
  Minus,
  MinusSquare,
  MoneyTime,
  Monitor,
  MusicSquare,
  Note,
  Notification,
  Paperclip,
  People,
  Personalcard,
  PercentageSquare,
  Play,
  PresentionChart,
  Printer,
  Profile2User,
  ProfileDelete,
  Receipt,
  ReceiptText,
  Refresh2,
  Repeat,
  RotateLeft,
  RowHorizontal,
  RulerPen,
  Scan,
  ShieldSecurity,
  SearchNormal1,
  Send2,
  Setting4,
  Wallet2,
  Wallet3,
  ShieldTick,
  Sms,
  Star1,
  StatusUp,
  TableDocument,
  Tag,
  TickCircle,
  TickSquare,
  Timer1,
  Translate,
  Trash,
  TrendDown,
  TrendUp,
  Truck,
  Unlock,
  User,
  UserAdd,
  UserRemove,
  UserSearch,
  UserSquare,
  UserTag,
  UserTick,
  Verify,
  VideoPlay,
  VideoSquare,
  VolumeHigh,
  Warning2,
  Camera,
  LanguageSquare,
  Logout,
  Mobile,
  Save2,
  Shop,
  Teacher,
  UserEdit,
  ArrowCircleDown,
  ArrowCircleUp,
  ElementPlus,
  LampCharge,
  MinusCirlce,
  PauseCircle,
  PlayCircle,
  SearchStatus,
  Ticket,
  Element3,
  Card,
  ClipboardText,
  Moon,
  Sun1,
  More,
  Setting2,
  Barcode,
  PasswordCheck,
  Forbidden2,
  TaskSquare,
  CalendarRemove,
  RowVertical
} from 'iconsax-react';

export const ICONS = {
  // verbs
  Add, // create
  Edit2, // edit
  Copy, // copy a reference
  Export, // export the list
  DocumentDownload, // download a file
  ExportSquare, // open in a new tab
  CloseCircle, // close, remove a chip
  Refresh2, // retry
  SearchNormal1, // search
  Setting4, // filters (sliders)
  // NB Iconsax names these by the direction of the ROW: RowHorizontal is
  // panels side by side (columns); RowVertical would be bars stacked.
  RowHorizontal, // columns
  Trash, // delete a record
  DocumentCopy, // duplicate a record
  Link2, // copy a link (the proposal the client opens)
  Sms, // an email (write one; one on record)
  MessageEdit, // reply to an email: write back in the same thread
  KeySquare, // sign-in and access of an account
  ShieldTick, // a person the HR portal knows
  // the row menu's three dots are drawn in CSS (ProjectListPieces `Dots`)
  // navigation glyphs
  ArrowLeft2,
  ArrowRight2,
  ArrowDown2,
  ArrowRight, // the arrow with a tail: the motion button's "go"
  // objects and states
  // the quote stages (quoteListTokens.js): Quote-TBS Edit (still being
  // written) · Quote-Open Timer1 (waiting on the client) · Quote-Won Cup ·
  // Sent To PM DirectboxSend (handed to production) · Quote-Lost CloseCircle
  Edit,
  Timer1,
  Cup,
  DirectboxSend,
  Notification, // the "needs attention" saved view of the quote lists
  Calendar, // a date field's glyph
  DocumentText, // a form, a document
  TableDocument, // a spreadsheet export
  Lock1, // sealed
  Alarm, // late or due today
  Flash, // rush
  TickCircle, // done, copied
  UserRemove, // nobody owns it
  Clock, // running now, today
  Headphone, // equipment on an event: booths, receivers
  // an AI interpreting session is the letters "AI" in Aura's pink, not a
  // glyph: the chip and the star were both sent back (the owner, 07/10/2026)
  MagicStar, // AI provenance (§20), uncoloured
  Cpu, // a machine where one is meant
  // the saved views of a list (§10)
  Activity, // all active
  User, // my projects, a person
  CalendarTick, // due this week
  Danger, // at risk
  // delivered: Send2, the Client Delivery stage's own glyph
  Category, // everything
  // the sections of a member's page (memberReports.js)
  Chart2, // a person's performance report
  Tag, // the sales report: quotes sent and won
  Building, // the clients a person looks after
  // the figures a report leads with
  Wallet2, // net revenue: what the work earned
  PercentageSquare, // a margin against its target
  ShieldSecurity, // quality cases raised against the work
  StatusUp, // a conversion rate
  // credit control (reports/credit): money owed past its date — a banknote
  // with a clock, picked by rendering it — and the client's proof of payment,
  // a receipt with its lines (`Receipt` draws a paper roll)
  MoneyTime,
  ReceiptText,
  // how a month moved against the one before it, on a report table
  TrendUp,
  TrendDown,
  // the nine stages of a translation project (§10)
  UserAdd, // to be claimed: somebody must take it
  UserTick, // claimed
  FolderOpen, // file preparation
  RulerPen, // formatting in progress
  UserSearch, // ready to allocate: a linguist is looked for
  Profile2User, // allocated: a linguist is assigned
  Translate, // translation in progress
  DirectboxReceive, // linguist delivery: the work came back
  Send2, // client delivery: sent out
  // the stages of a patent project that are its own (§10)
  Broom, // cleaning in progress: the files are cleaned
  Eye, // final eye check; a password shown
  EyeSlash, // a password hidden
  // the stages of an interpretation project that are its own (§10): the
  // first three are the translation list's, Delivered is "done"
  CalendarEdit, // postponed: the date is being moved
  // the verbs and facts of a project workspace (the translation project page,
  // 07/10/2026): each one is drawn once, for one meaning
  ArrowLeft, // back to the list
  ArrowSwapHorizontal, // negotiate the terms
  ArrowUp2, // read less, collapse
  ArchiveBook, // a Word template
  Bill, // an expense
  Call, // a phone number
  Chart, // the Atlas report
  ClipboardTick, // the delivery checklist
  Cloud, // Atlas, the translation platform
  Document, // a file with no known kind
  DocumentUpload, // upload a file
  Flag, // where the project really is (the panel's "you are on step N")
  Folder2, // the vault, manage the files
  Gallery, // an image file
  Global, // a language, the pair
  InfoCircle, // why the project is here; details
  Link21, // link an existing Atlas project; a copyable link
  Location, // an address
  Maximize4, // zoom in
  MedalStar, // the best matches
  MessageQuestion, // why this ranking
  Minus, // zoom out
  MinusSquare, // deselect the rows on screen; close a breakdown that is open
  AddSquare, // open a breakdown on a row (the CAT match bands of a line)
  Paperclip, // an attachment
  People, // every translator
  Play, // start the preparation
  Printer, // the booking form print-out
  Receipt, // create an invoice
  Repeat, // send the offer again
  RotateLeft, // back to the current step; send back
  Scan, // the Layout conversion
  // A RATING AND A SHORTLIST: the star — but NEVER its `Bold` variant (the
  // owner, 08/10/2026: "I don't get why there is a cross over the star
  // icon"; again on the interpreters roster, 09/10/2026). Iconsax ships no
  // plain filled star: `Star` is a SHOOTING star, with three speed lines
  // beside it, and `Star1`'s Bold form is cut through by a diagonal slash
  // that at 13px reads as a star struck out. The LINEAR path is the clean
  // outline, and the solid star is that same path filled: ask the Icon for
  // `solid`, never for `variant="Bold"` (Icon.js, tested in Icon.test.js).
  // The fix had to be made twice because the rule lived in one list's file;
  // it is on the Icon now, so no surface has to know about the slash.
  Star1,
  TickSquare, // select the rows on screen
  Unlock, // reopen the financials
  Verify, // accept, confirm
  Warning2, // something is not ready yet
  // Bits & Bobs (08/10/2026): the small things served across the team — the
  // level of a bit, the thread on one, and the departments a bit is served to
  ArrowDown, // a lower level: a low-priority bit
  Messages2, // a rally: the thread of questions and replies on one bit
  Buildings2, // a department: a shared inbox, not one person
  Kanban, // the project desks (PM CI, PM LY)
  UserTag, // the account desks (AM CI, AM LY): the desk that owns the client
  UserSquare, // HR: the people records
  VolumeHigh, // marketing
  Code, // development
  // the Tasks department cards (08/10/2026): the symbol of each department's
  // trade, chosen by rendering the candidates rather than by their names —
  // Iconsax's `Receipt`, which §10's rail map gives Finance, draws a curled
  // paper roll (the owner: "finance is a toilette paper"). Project Management
  // keeps the Kanban above and Marketing the speaker; no two share a
  // silhouette, so a department is read by shape before by word.
  Briefcase, // the account desks: the desk that owns the client
  Wallet3, // finance: the money, not a receipt
  Personalcard, // HR: the people records, an ID card
  Code1, // development: a terminal prompt
  Crown, // the CEO board
  // the vocabulary of an interpreting event (the event workspace,
  // 08/10/2026): how a session is delivered, and what an expense is for
  Microphone2, // consecutive and chuchotage: a voice, no booth
  Monitor, // a remote session: the platform it runs on
  Car, // travel, board and lodging on an expense row
  Box1, // shipping: equipment sent to the venue
  // what a translation carries besides the translation (the translation
  // list, 30/10/2026): a sworn, legalised or apostilled copy is the seal of a
  // certificate (the gavel was sent back: "fai un'icona più pertinente"), and
  // the shipping of the stamped copy the truck the owner asked for
  Medal,
  Truck,
  // the ways an interpreter works (the interpreters list, 08/10/2026): the
  // five stored modes are told apart by their glyph, not by five colours —
  // Microphone2 a voice in the room, Headphone a booth, VideoSquare a video
  // call, Monitor a remote simultaneous platform, Call a phone line (§10)
  VideoSquare, // a remote consecutive session: a video call
  // THE DIALER (08/10/2026): a call is read by what happened to it, so the
  // four stored outcomes get four shapes — it went out and connected, it
  // rang and rang, the line turned it away, it was never rung at all — and
  // the three verbs of a live call get the microphone, the pause and the
  // dropped handset. `Eraser` deletes the last digit of a number being
  // typed: Iconsax draws no backspace, and an eraser says the same thing.
  CallCalling, // ringing, and a call that rang unanswered
  CallOutgoing, // the call went out and was answered
  CallRemove, // the line was busy: it turned the call away
  CallSlash, // hang up; a call that was never routed
  MicrophoneSlash, // muted
  Eraser, // delete the last digit
  // a vendor struck off a service (the blacklist verb on a roster): a person
  // taken out of the book, never the plain Trash of a deleted record
  ProfileDelete,
  // THE VAULT (08/10/2026). A vault is 115 000 files in seven folders, and
  // the only thing that tells a reader what a row IS at a glance is the kind
  // of file it holds — so the file type is a GLYPH on the neutral label, the
  // answer §15 already gives a high-cardinality category (eighteen brochure
  // families, a language pair), never a colour per extension.
  //
  // The FOLDERS: `Folder` closed for a folder that holds nothing, the open
  // one for a folder that does, `FolderAdd` the verb that makes one.
  Folder,
  FolderAdd,
  // The FILE KINDS: Iconsax has no per-extension glyph, so each is the
  // nearest true shape — a page of text, a page of numbers, a page of
  // slides, a picture, a frame of film, a waveform, a box of files, a
  // drawing, a page of code, a plain note.
  DocumentCode, // xml, json, html, xliff, sdlxliff
  DocumentSketch, // ai, psd, indd: artwork
  Image,
  VideoPlay,
  MusicSquare, // audio
  Archive, // zip, rar, 7z: a folder in a file
  ArchiveBox, // the vault itself, in the rail and on an empty state
  PresentionChart, // ppt, pptx, key
  Note, // txt, md, csv read as notes rather than as a spreadsheet
  CopySuccess, // a link that has just been copied
  // THE VENDOR DOOR (10/10/2026): the onboarding a linguist walks after
  // registering. A sub-step is named by what it asks for — the person, the
  // business, the languages, the CV, the schooling, the services and the
  // tools — and the two verbs of the shell: save and leave, sign out.
  Camera, // take a photo of the CV (touch only)
  LanguageSquare, // the languages step and the language pairs
  Logout, // sign out of the onboarding
  Mobile, // the phone number a vendor is reached on
  Save2, // save and exit
  Shop, // a company or an individual
  Teacher, // education
  UserEdit, // the profile being built
  // HELP & SUPPORT (12/10/2026): what a ticket is, how urgent, and where it
  // stands. Picked by their Bold form, which is what a label and a strip
  // draw — Star1 is cut by a slash there and Status turns into a cap.
  Ticket, // a ticket; every ticket
  ElementPlus, // ask for a feature: something added to the portal
  LampCharge, // share an idea
  PauseCircle, // a paused vendor: no login, no work, resumable (29/10/2026)
  PlayCircle, // in progress
  SearchStatus, // testing: being checked
  ArrowCircleUp, // high priority
  MinusCirlce, // medium priority (Iconsax spells it so)
  ArrowCircleDown, // low priority
  // THE VENDOR PORTAL (12/10/2026): the destinations of the vendor rail and
  // its account menu — the dashboard as the grid of its blocks, the payment
  // details as the card the money goes to, a technician's job sheet as the
  // clipboard it is filled on, and the three verbs of the account: the two
  // modes of the theme and More, the fifth slot of the phone bar (§12).
  Element3, // the dashboard
  Card, // payment details: where the money goes
  ClipboardText, // a technician sheet
  Moon, // dark mode
  Sun1, // light mode
  More, // the phone bar's More
  // THE TECHNICIAN'S INVENTORY AND THE ACCOUNT (13/10/2026): a piece of
  // equipment being serviced (the gear it is opened with), the serial number
  // printed on it, a password being changed, and a page the account may not
  // open.
  Setting2, // inventory: under maintenance
  Barcode, // inventory: the serial number
  PasswordCheck, // the change-password page
  Forbidden2, // a page this account cannot open
  // THE TASK BOARDS (14/10/2026): a task is the ticked square of a to-do
  // list; a task with no day to be done by is the calendar struck off; and
  // the board's two views are the kanban's columns (`Kanban`, above) and the
  // stacked bars of a list — Iconsax names those `RowVertical` (§10 NB).
  TaskSquare, // a task; every task on the board
  CalendarRemove, // no due date
  RowVertical // the list view of a board
};
